module.exports = __webpack_public_path__ + "static/media/info_5.321cbe28.svg";